import Modal from './message-box'


export default Modal



// WEBPACK FOOTER //
// ./src/components/message-box/index.js